import "./programs.scss";
import { Link } from "react-router-dom";

// Programs section (added 2026-10-21 at the owner's request):
// Little Tigers for ages 2.5-5 focused on discipline, and a specialized
// adult program. Copy stays with what the owner specified — no invented
// schedules, prices, or results.
export default function Programs() {
  return (
    <section className="section programs-section" id="programs">
      <div className="container programs-container">
        <p className="programs-eyebrow">OUR PROGRAMS</p>
        <h2 className="programs-title">A Class for Every Age</h2>
        <p className="programs-lead">
          From toddlers taking their very first class to adults training for
          fitness and self-defense — every student starts with 1 FREE class.
        </p>

        <div className="grid programs-grid">
          <div className="program-card">
            <div className="program-icon" aria-hidden="true">
              🐯
            </div>
            <h3>Little Tigers</h3>
            <p className="program-ages">Ages 2½ – 5</p>
            <p className="program-text">
              A first class made just for little ones. In a fun, structured
              class, our youngest students learn to listen, follow directions
              and control their bodies — the discipline they build here
              carries into school and home.
            </p>
            <ul className="program-points">
              <li>Discipline &amp; self-control</li>
              <li>Listening &amp; focus</li>
              <li>Respect &amp; confidence</li>
              <li>Balance &amp; coordination</li>
            </ul>
            <Link to="/#trial" className="program-cta">
              Book a FREE Class
            </Link>
          </div>

          <div className="program-card">
            <div className="program-icon" aria-hidden="true">
              🥋
            </div>
            <h3>Adult Taekwondo</h3>
            <p className="program-ages">Specialized Classes for Adults</p>
            <p className="program-text">
              Not a kids' class with adults in it — a program built for
              adults. Get in shape, relieve stress and learn practical
              self-defense, training at your own pace with expert
              instruction. No experience needed.
            </p>
            <ul className="program-points">
              <li>Full-body fitness</li>
              <li>Stress relief</li>
              <li>Practical self-defense</li>
              <li>Train at your own pace</li>
            </ul>
            <Link to="/#trial" className="program-cta">
              Try 1 Class FREE
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
